import React from "react";
import Wrapper from "./Wrapper";
import HomeQrCode from "../HomeQrCode";
const VmViewerMobile = (props) => {
  return <HomeQrCode {...props} />;
};

export default Wrapper(VmViewerMobile);
